module.exports = __webpack_public_path__ + "static/media/react1Jss.c8a0cc23.png";